module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/store_images/5@2x_dc7b2085b9b95bc6757bee8a00f10a63.png";